var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
const CrossLogo = (_a) => {
    var { size = 15 } = _a, rest = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ width: size, height: size, viewBox: "0 0 15 15", fill: "none" }, rest),
        React.createElement("path", { d: "M7.43701 14C11.0614 14 13.9995 11.0619 13.9995 7.4375C13.9995 3.81313 11.0614 0.875 7.43701 0.875C3.81264 0.875 0.874512 3.81313 0.874512 7.4375C0.874512 11.0619 3.81264 14 7.43701 14Z", fill: "white", stroke: "#E4E8EC", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M8.53125 6.34375V4.15625H6.34375V6.34375H4.15625V8.53125H6.34375V10.7188H8.53125V8.53125H10.7188V6.34375H8.53125Z", fill: "#FF5331" })));
};
export default CrossLogo;
